import { render, staticRenderFns } from "./HoldingLoansTable.vue?vue&type=template&id=13c0e94f&"
import script from "./HoldingLoansTable.vue?vue&type=script&lang=js&"
export * from "./HoldingLoansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports